<template>
    <div class="relative mt-4 mobile:p-2.5 pt-4 tablet:p-3 rounded-[10px] bg-[#F1F1F1]/50">
        <div class="flex tablet:gap-2 justify-between items-start">
            <h6
                class="w-3/5 mobile:mb-2 tablet:m-0 font-roboto font-semibold mobile:text-lg tablet:text-[20px] text-[#333333]"
>
                {{ bundle.bundle_name }}
</h6>
            <div class="w-2/5 flex justify-end">
                <div class="text-left">
                    <p class="m-0 text-[16px] font-medium font-roboto text-[#999999]">
{{ bundle.bundle_month }} months
                        plan
</p>
                    <h4 class="m-0 mobile:text-lg tablet:text-2xl font-roboto font-bold text-[#333]">
                        ${{ $helper.formatAmount(bundle.bundle_amount) }}/mo
</h4>
                </div>
            </div>
        </div>
        <div v-for="(planDetail, index) in bundle.items" :key="index" class="flex flex-col gap-1 mb-3">
            <h6
                class="m-0 text-[12px] rounded-full px-2 py-1 inline-block w-max shadow-[0_0_4px_0_#00000026] text-[#A084E8] bg-[#fff]"
>
                {{
                planDetail.trade_name }}
</h6>
            <h2 class="m-0 font-roboto text-[16px] text-[#333333]">
{{ planDetail.plan_name }}
</h2>
        </div>
        <div v-if="bundle.is_show_quantity == 0" class="absolute -top-[16px] right-[16px]">
            <!-- min 640px screen size   -->
            <button
type="button" class="group h-8 w-8 mobile:hidden tablet:flex items-center justify-center rounded-full focus:outline-0 transition-all border-1 bg-[#fff] border-[#F67280] hover:!bg-[#F67280] [@media(max-width:1023px)]:!bg-[#F67280]"
                @click="updateCounter('remove')"
>
                <img
src="../../assets/images/trash-icon-updated.png" alt="Cart Icon"
                    class="mobile:!w-5 mobile:!h-5 tablet:w-7 tablet:h-7 group-hover:hidden [@media(max-width:1023px)]:!hidden object-contain"
>
                <img
src="../../assets/images/trash-icon-white-updated.png" alt="Cart Icon"
                    class="mobile:!w-5 mobile:!h-5 tablet:w-7 tablet:h-7 hidden group-hover:!block [@media(max-width:1023px)]:!block"
>
            </button>
            <!-- after 640px screens -->
            <button
type="button" class="group h-8 w-8  tablet:hidden mobile:flex items-center justify-center rounded-full focus:outline-0 border-1 border-[#F67280] bg-[#F67280]"
                @click="updateCounter('remove')"
>
                <img
src="../../assets/images/trash-icon-white-updated.png" alt="Cart Icon"
                    class="mobile:!w-5 mobile:!h-5 tablet:w-7 tablet:h-7 "
>
            </button>
        </div>

        <div class="flex items-center gap-[10px]">
            <div
v-if="bundle.is_show_quantity == 1"
                class="tablet:w-max mobile:flex mobile:justify-between mobile:items-center mobile:w-full "
>
                <quantityCounter
v-if="bundle.is_show_quantity == 1" :quantity="bundle.bundle_quantity"
                    @update-counter="updateCounter"
/>
                <button
v-else type="button" class="group h-10 w-10 flex items-center justify-center rounded-full focus:outline-0 transition-all border-1 border-[#F67280] hover:bg-[#F67280] [@media(max-width:1023px)]:!bg-[#F67280]"
                    @click="updateCounter('remove')"
>
                    <img
src="../../assets/images/trash-icon-updated.png" alt="Cart Icon"
                        class="mobile:!w-5 mobile:1h-5 tablet:w-7 tablet:h-7 group-hover:hidden [@media(max-width:1023px)]:!hidden object-contain"
>
                    <img
src="../../assets/images/trash-icon-white-updated.png" alt="Cart Icon"
                        class="mobile:!w-5 mobile:!h-5 tablet:w-7 tablet:h-7 hidden group-hover:!block [@media(max-width:1023px)]:!block"
>
                </button>
            </div>
            <div
v-if="showViewDetail"
                class="group cursor-pointer w-[35px] h-[35px] flex items-start justify-center rounded-full shadow-[0_0_4px_0_#00000026] p-[5px] ttransition duration-300 bg-[#fff] hover:bg-[#7695FF] [@media(max-width:1023px)]:!bg-[#7695FF]"
>
                <img src="../../assets/images/eye-purple-icon.svg" alt="" class="w-full h-full group-hover:hidden [@media(max-width:1023px)]:!hidden">
                <img src="../../assets/images/eye-white-icon.svg" alt="" class="w-full h-full hidden group-hover:block [@media(max-width:1023px)]:!block">
            </div>
        </div>
    </div>
</template>


<script>
import quantityCounter from '../partialComponent/quantityCounter.vue';

export default {
    components: {
        quantityCounter
    },
    props: {
        bundle: Object,
        isSelected: Boolean,
        updateCart: Function,
        updateCard: Object,
        showViewDetail: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localObject: null
        }
    },

    watch: {
        // updateCard: function (data) {
        //     if (data && this.localObject) {
        //         this.plan.quantity = this.localObject.quantity
        //     }
        //     // this.localObject = null
        // },
    },

    methods: {
        updateCounter(option) {
            
            this.localObject = JSON.parse(JSON.stringify(this.bundle))

            if (option == "increment") {
                this.localObject.bundle_quantity++
            } else if (option == "decrement" || option == "remove") {
                if (this.localObject.bundle_quantity > 1) {
                    this.localObject.bundle_quantity--
                } else {
                    this.localObject.bundle_quantity = 0
                }
            } else {
                this.localObject.bundle_quantity = 0
            }
            this.updateCart(option, {
                id: this.localObject.bundle_id,
                quantity: this.localObject.bundle_quantity,
                partner_id: this.localObject.partner_id,
                type: 'bundle'
            })
        },
    }
}
</script>